var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourSeeds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 6,
    cx: 18.84919134469164,
    cy: 25.579805749705027
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6,
    cx: 32.400606194072886,
    cy: 24.420211574897014
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.8125,
    cx: 24.739783352748436,
    cy: 14.653873630500604
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.8125,
    cx: 26.510417348652435,
    cy: 35.34610919548636
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourSeeds);
export default __webpack_public_path__ + "static/media/four_seeds.e5d6c54e82ca0d0e705697d81b08fd68.svg";
export { ForwardRef as ReactComponent };